<template>
  <div>
    <div
      v-if="widthNow >= 550"
      class="Text-Hero"
      v-bind:style="{
        'font-size': fontSize,
        'margin-left': marginLeft,
        width: width,
        'margin-top': marginTop,
      }"
    >
      Menyelesaikan Tantangan Sulit Membutuhkan Talenta Terbaik
      <div
        class="pt-4 pb-8"
        v-bind:style="{
          'font-size': fontSizeSmall,
        }"
      >
        Kami bekerja mewujudkan dampak sosial dan inklusi keuangan di Indonesia.
      </div>
      <v-btn
        class="white--text text-none px-8"
        color="black"
        rounded
        v-bind:style="{
          'font-size': fontSizeSmall,
        }"
        @click="scroll('recruitment')"
        >Lihat Posisi Tersedia</v-btn
      >
    </div>
    <div v-else class="Text-Hero-Mobile">
      Menyelesaikan Tantangan Sulit Membutuhkan Talenta Terbaik
      <div class="py-4 text-body-2">
        Kami bekerja mewujudkan dampak sosial dan inklusi keuangan di Indonesia.
      </div>
      <v-btn
        class="white--text text-none px-6"
        color="black"
        rounded
        @click="scroll('recruitment')"
        >Lihat Posisi Tersedia</v-btn
      >
    </div>
    <v-skeleton-loader
      type="image"
      max-height="545"
      v-if="!isImgLoaded && widthNow >= 550"
    ></v-skeleton-loader>
    <v-skeleton-loader
      type="image"
      max-height="545"
      v-if="!isImgLoaded && widthNow >= 550"
    ></v-skeleton-loader>
    <v-skeleton-loader
      type="image"
      max-height="506"
      v-if="!isImgLoaded && widthNow <= 550"
    ></v-skeleton-loader>
    <v-skeleton-loader
      type="image"
      max-height="506"
      v-if="!isImgLoaded && widthNow <= 550"
    ></v-skeleton-loader>
    <img
      v-if="widthNow >= 550"
      src="../assets/career/Hero.svg"
      @load="onImgLoad"
      class="Hero"
    />
    <img
      v-else
      src="../assets/career/bg-1-mobile.png"
      @load="onImgLoad"
      class="Hero-Mobile"
    />
    <SiapaKami v-if="widthNow >= 550" />
    <SiapaKamiMobile v-else />
    <!-- <Benefits v-if="widthNow >= 550" />
    <BenefitsMobile v-else /> -->
    <Culture v-if="widthNow >= 550" />
    <CultureMobile v-else />

    <!-- <v-layout align-center column style="margin-top:100px;">
      <p class="title-a">Testimonial Karyawan</p>
      <TestiEmployee v-if="widthNow >= 1200" :testi="testiPeminjam" />
      <TestiEmployeeMobile v-if="widthNow <= 1200" :testi="testiPeminjam" />
    </v-layout> -->
    <Recruitment id="recruitment" />
  </div>
</template>
<script>
import SiapaKami from "../components/Career/SiapaKami.vue";
import SiapaKamiMobile from "../components/Career/SiapaKamiMobile.vue";
// import Benefits from "../components/Career/Benefits.vue";
// import BenefitsMobile from "../components/Career/BenefitsMobile.vue";
import Culture from "../components/Career/Culture.vue";
import CultureMobile from "../components/Career/CultureMobile.vue";
// import TestiEmployee from "../components/Career/TestiEmployee.vue";
// import TestiEmployeeMobile from "../components/Career/TestiEmployeeMobile.vue";
import Recruitment from "../components/Career/Recruitment.vue";

export default {
  components: {
    SiapaKami,
    SiapaKamiMobile,
    // Benefits,
    // BenefitsMobile,
    Culture,
    CultureMobile,
    // TestiEmployee,
    // TestiEmployeeMobile,
    Recruitment,
  },
  data() {
    return {
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 6}px`,
      width: `${window.innerWidth / 4}px`,
      widthNow: window.innerWidth,
      fontSize: `40px`,
      fontSizeSmall: `20px`,
      isImgLoaded: false,
      testiPeminjam: [
        // {
        //   name: "Wiyudo",
        //   job: "Tambak Udang",
        //   desc: `Selama 3 tahun bekerja sama dengan Dompet Kilat, saya sangat terbantu karena kita bisa mengajukan pinjaman tanpa agunan. Dompet Kilat juga menyediakan ekosistem pendanaan yang sangat membantu dalam penyediaan kebutuhan. Terima kasih Dompet Kilat!`,
        //   img: require("../../assets/pinjaman/user/placeholder-testimoni.png"),
        // },
        {
          name: "Wiyudo",
          job: "Tambak Udang",
          desc: `Selama 3 tahun bekerja sama dengan Dompet Kilat, saya sangat terbantu karena kita bisa mengajukan pinjaman tanpa agunan. Dompet Kilat juga menyediakan ekosistem pendanaan yang sangat membantu dalam penyediaan kebutuhan. Terima kasih Dompet Kilat!`,
          img: require("../assets/pinjaman/user/placeholder-testimoni.png"),
        },
        {
          name: "Muhammad Chandra ",
          job: "Security",
          desc: `Program pembiayaan seragam dari Dompet Kilat sangat membantu saya agar dapat bekerja menggunakan seragam security yang telah ditentukan oleh perusahaan. Prosesnya gampang dan cepat! Terima kasih Dompet Kilat.
`,
          img: require("../assets/pinjaman/user/placeholder-testimoni.png"),
        },
        {
          name: "Tabrani",
          job: "Petani",
          desc: `Dompet Kilat bekerjasama dengan beberapa pihak diantaranya PT. Bayer, Indo Buana Berkah & asuransi yang dapat mendampingi kami para petani agar mendapatkan hasil yang maksimal. Terima kasih Dompet Kilat!
`,
          img: require("../assets/pinjaman/user/placeholder-testimoni.png"),
        },
      ],
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTop = `${window.innerWidth / 10}px`;
      this.width = `${window.innerWidth / 4}px`;
      this.fontSize = `${window.innerWidth / 34}px`;
      this.fontSizeSmall = `${window.innerWidth / 92}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    onImgLoad() {
      this.isImgLoaded = true;
    },
    scroll(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
    },
  },
};
</script>
<style scoped>
.Text-Hero {
  width: 763px;
  margin: 137px 810px 0 200px;
  font-family: Sora;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  position: absolute;
}

.Text-Hero-Mobile {
  position: absolute;
  height: 120px;
  flex-grow: 0;
  margin: 40px 30px 0;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.48px;
  text-align: center;
  color: #252525;
}

.title-a {
  max-width: 438px;
  max-height: 30px;
  flex-grow: 0;
  margin: 0px 305px 60px 305px;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}

.Hero {
  width: 100%;
  object-fit: contain;
}

.Hero-Loader {
  width: 100%;
  height: 545px;
}

.Hero-Mobile {
  width: 100%;
  object-fit: contain;
  margin-top: -50px;
}
</style>
